import { render, staticRenderFns } from "./diantaoLiveShevles.vue?vue&type=template&id=acf13f00"
import script from "./diantaoLiveShevles.vue?vue&type=script&lang=js"
export * from "./diantaoLiveShevles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports